 document.addEventListener("DOMContentLoaded", function () {
document.addEventListener("click", function (e) {
  const swatchLink = e.target.closest(".cstm-swatches a");
  if (!swatchLink) return; // not a swatch click

  e.preventDefault();

  // get clicked <img> HTML
  const clickedImg = swatchLink.querySelector("img");
  if (!clickedImg) return;

  // find the closest product card
  const card = swatchLink.closest(".card.product-card.product-card--card");
  if (!card) return;

  // find first media image inside flickity slider
  const targetImg = card.querySelector(".flickity-slider .media.media--height img");
  if (!targetImg) return;

  // replace full <img> element with clicked one (clone)
  targetImg.replaceWith(clickedImg.cloneNode(true));
});


});